import React from 'react';
import PropTypes from 'prop-types';
import { useOutletContext } from 'react-router-dom';
import AmexGDA from '../../AmexGDA';
import AmexGDADir from '../../AmexGDADir';
import AmexDynamicTermsB2B from '../../AmexDynamicTermsB2B';
import AmexShopSmall from '../../AmexShopSmall';
import AmexExperiential from '../../AmexExperiential';
import AmexGDAB2B from '../../AmexGDAB2B';
import AmexSecurityCenter from '../../AmexSecurityCenter';
import AmexResyCredit from '../../AmexResyCredit';
import AmexResyValue from '../../AmexResyValue';
import AmexPlatinumNights from '../../AmexPlatinumNights';
import ResyRewards from '../../ResyRewards';

const commonPropTypes = {
  $location: PropTypes.shape({
    search: PropTypes.func.isRequired,
    path: PropTypes.func.isRequired,
  }).isRequired,
  $rootScope: PropTypes.shape({
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      ipadLandscape: PropTypes.bool,
      xl: PropTypes.bool,
    }),
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
};

const AmexGDAOutlet = (props) => {
  const { collections, loadNotifyModal, onLogin } = useOutletContext();
  const {
    $location, $rootScope, Analytics, Config, ResyAmexConfig,
  } = props;
  return (
    <AmexGDA
      collections={collections}
      loadNotifyModal={loadNotifyModal}
      onLogin={onLogin}
      matchMedia={$rootScope.matchMedia}
      $location={$location}
      $rootScope={$rootScope}
      Analytics={Analytics}
      Config={Config}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AmexGDAOutlet.propTypes = {
  ...commonPropTypes,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  Config: PropTypes.shape({
    origin: PropTypes.string.isRequired,
  }).isRequired,
};

const AmexGDADirOutlet = (props) => {
  const { collections } = useOutletContext();
  const {
    $location, Analytics, ResyAmexConfig,
  } = props;
  return (
    <AmexGDADir
      collections={collections}
      $location={$location}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AmexGDADirOutlet.propTypes = {
  ...commonPropTypes,
};

const AmexDynamicTermsOutlet = (props) => {
  const { setDynamicTermsTitle } = useOutletContext();
  const {
    $location, ResyAmexConfig,
  } = props;
  return (
    <AmexDynamicTermsB2B
      setDynamicTermsTitle={setDynamicTermsTitle}
      $location={$location}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AmexDynamicTermsOutlet.propTypes = {
  ...commonPropTypes,
};

const AmexShopSmallOutlet = (props) => {
  const {
    isAuthenticated,
    showSignupModal,
    loadNotifyModal,
    showAuthModal,
  } = useOutletContext();

  const {
    $location, ResyAmexConfig, $rootScope, $routeParams, Analytics, $window,
  } = props;
  return (
    <AmexShopSmall
      $location={$location}
      Analytics={Analytics}
      isAuthenticated={isAuthenticated}
      $rootScope={$rootScope}
      ResyAmexConfig={ResyAmexConfig}
      matchMedia={$rootScope.matchMedia}
      loadNotifyModal={loadNotifyModal}
      showSignupModal={showSignupModal}
      $routeParams={$routeParams}
      showAuthModal={showAuthModal}
      $window={$window}
    />
  );
};

AmexShopSmallOutlet.propTypes = {
  ...commonPropTypes,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  $window: PropTypes.shape({}).isRequired,
};

const AmexExperientialOutlet = (props) => {
  const {
    isAuthenticated,
    showSignupModal,
    loadNotifyModal,
    showAuthModal,
  } = useOutletContext();

  const {
    $location, ResyAmexConfig, $rootScope, $routeParams, Analytics, $window,
  } = props;
  return (
    <AmexExperiential
      $location={$location}
      Analytics={Analytics}
      isAuthenticated={isAuthenticated}
      $rootScope={$rootScope}
      ResyAmexConfig={ResyAmexConfig}
      matchMedia={$rootScope.matchMedia}
      loadNotifyModal={loadNotifyModal}
      showSignupModal={showSignupModal}
      $routeParams={$routeParams}
      showAuthModal={showAuthModal}
      $window={$window}
    />
  );
};

AmexExperientialOutlet.propTypes = {
  ...commonPropTypes,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  $window: PropTypes.shape({}).isRequired,
};

const AmexGDAB2BOutlet = (props) => {
  const {
    isAuthenticated,
    showSignupModal,
    loadNotifyModal,
    showAuthModal,
  } = useOutletContext();

  const {
    $location, ResyAmexConfig, $rootScope,
    $routeParams, Analytics, $window,
  } = props;
  return (
    <AmexGDAB2B
      $location={$location}
      $rootScope={$rootScope}
      Analytics={Analytics}
      isAuthenticated={isAuthenticated}
      ResyAmexConfig={ResyAmexConfig}
      loadNotifyModal={loadNotifyModal}
      showSignupModal={showSignupModal}
      $routeParams={$routeParams}
      showAuthModal={showAuthModal}
      $window={$window}
    />
  );
};

AmexGDAB2BOutlet.propTypes = {
  ...commonPropTypes,
  $window: PropTypes.shape({}).isRequired,
};

const AmexSecurityCenterOutlet = (props) => {
  const { collections, loadNotifyModal, onLogin } = useOutletContext();
  const {
    $location, $rootScope, $routeParams, Analytics, ResyAmexConfig,
  } = props;
  return (
    <AmexSecurityCenter
      collections={collections}
      loadNotifyModal={loadNotifyModal}
      onLogin={onLogin}
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AmexSecurityCenterOutlet.propTypes = {
  ...commonPropTypes,
};

const AmexResyCreditOutlet = (props) => {
  const {
    collections, loadNotifyModal, onLogin, showAuthModal,
  } = useOutletContext();
  const {
    $location, $rootScope, $routeParams, Analytics, ResyAmexConfig,
  } = props;
  return (
    <AmexResyCredit
      collections={collections}
      loadNotifyModal={loadNotifyModal}
      onLogin={onLogin}
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
      showAuthModal={showAuthModal}
    />
  );
};

AmexResyCreditOutlet.propTypes = {
  ...commonPropTypes,
};

const AmexResyValueOutlet = (props) => {
  const { collections, loadNotifyModal, onLogin } = useOutletContext();
  const {
    $location, $rootScope, $routeParams, Analytics, ResyAmexConfig,
  } = props;
  return (
    <AmexResyValue
      collections={collections}
      loadNotifyModal={loadNotifyModal}
      onLogin={onLogin}
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AmexResyValueOutlet.propTypes = {
  ...commonPropTypes,
};

const AmexPlatinumNightsOutlet = (props) => {
  const {
    collections, loadNotifyModal, onLogin, showAuthModal,
  } = useOutletContext();
  const {
    $location, $rootScope, $routeParams, Analytics, ResyAmexConfig,
  } = props;
  return (
    <AmexPlatinumNights
      collections={collections}
      loadNotifyModal={loadNotifyModal}
      onLogin={onLogin}
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
      showAuthModal={showAuthModal}
    />
  );
};

AmexPlatinumNightsOutlet.propTypes = {
  ...commonPropTypes,
};

const ResyRewardsOutlet = (props) => {
  const {
    $location, $rootScope, $routeParams, Analytics, ResyAmexConfig,
  } = props;
  return (
    <ResyRewards
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

ResyRewardsOutlet.propTypes = {
  ...commonPropTypes,
};

export {
  AmexGDAOutlet,
  AmexGDADirOutlet,
  AmexDynamicTermsOutlet,
  AmexShopSmallOutlet,
  AmexExperientialOutlet,
  AmexGDAB2BOutlet,
  AmexSecurityCenterOutlet,
  AmexResyCreditOutlet,
  AmexResyValueOutlet,
  AmexPlatinumNightsOutlet,
  ResyRewardsOutlet,
};
